import React, { Component } from 'react';
import Button from '../../components/Button';
import styles from './RenderList.module.css';
import TableView from '../../components/TableView';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchJobs, getRenders, getSearchedRenders } from '../../modules/jobs';
import moment from 'moment';
import Search from '../../components/Search';

class RenderList extends Component {
  state = {
    mode: 'normal',
    keyword: null,
    page: 0,
    headers: ['Collection', 'Author', 'Job Date/Time', 'Status', 'Duration'],
  };

  static contextTypes = {
    router: propTypes.object,
  };

  async componentDidMount() {
    const { fetchJobs } = this.props;
    await fetchJobs();
  }

  navTo = (id, catogary) => {
    const { router } = this.context;
    const url = catogary ? `/${catogary}/${id}` : `/${id}`;
    const { history } = router;
    history.push(url);
  };

  openRender = id => {
    this.navTo(id, 'renderings');
  };

  viewNextPage = async next => {
    const { page, mode, keyword } = this.state;
    const { fetchJobs } = this.props;
    if (page === 0 && next === -1) return;
    const newPage = page + next;
    const query = {
      page: newPage,
    };
    if (mode === 'search') {
      query.name = keyword;
    }
    await fetchJobs(query);
    this.setState({ page: newPage });
  };

  searchRenders = async keyword => {
    if (!keyword) {
      this.setState({ keyword, mode: 'normal' });
      return;
    }
    const { fetchJobs } = this.props;
    await fetchJobs({ name: keyword });
    this.setState({ mode: 'search', keyword });
  };

  render() {
    const { renders, searchedRenders } = this.props;
    const { headers, mode } = this.state;
    const data = mode === 'search' ? searchedRenders : renders;
    const content = data.map(item => [
      {
        label: item.name || (item.collection && item.collection.name),
        value: item._id,
      },
      item.user || 'ziyang',
      moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss'),
      item.status || 'Complete',
      item.finishedAt
        ? moment
            .duration(moment(item.finishedAt).diff(item.createdAt))
            .asHours()
            .toFixed(1) + ' hours'
        : '1h',
    ]);
    return (
      <div className={styles.container}>
        <div className={styles.header}> Renderings </div>
        <div className={styles.description}>
          View recent previews, current images, or create your own renderings
        </div>
        <div className={styles.newRenderContainer}>
          <div className={styles.newRenderTitle}> Create Rendering Job </div>
          <div className={styles.renderSubTitle}>
            <div>
              <Button
                text="New Rendering Job"
                onClick={e => this.navTo('new', 'renderings')}
              />
              <span
                className={styles.dulplicateAsset}
                onClick={e => this.navTo('rename', 'renderings')}
              >
                Duplicate and Rename Assets
              </span>
            </div>
            <Search
              placeholder="Search Renderings"
              onAction={this.searchRenders}
            />
          </div>
        </div>
        <hr className={styles.divider} />
        <div className={styles.renderJobsList}>
          <div className={styles.newRenderTitle}>Rendering Jobs</div>
          <TableView
            headers={headers}
            data={content}
            rowColor="#2375C2"
            onClick={this.openRender}
          />
          <div className={styles.paginationContainer}>
            <div
              className={styles.paginator}
              onClick={() => this.viewNextPage(-1)}
            >
              Prev
            </div>
            <div
              className={styles.paginator}
              onClick={() => this.viewNextPage(1)}
            >
              Next
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const stateToProps = state => ({
  renders: getRenders(state),
  searchedRenders: getSearchedRenders(state),
});

export default connect(
  stateToProps,
  { fetchJobs }
)(RenderList);



// WEBPACK FOOTER //
// ./src/containers/RenderList/index.js